import { HubFeature } from '@ats/api/cm';
import { LocDefs, LocMap, LocPortal, MapLocKeys } from '@cm/core/localization';

export type SPBenefitTokenCountsLocs =
	| 'SPBenefitTokenCountsLabelAvailable'
	| 'SPBenefitTokenCountsLabelInvalid'
	| 'SPBenefitTokenCountsLabelExpired'
	| 'SPBenefitTokenCountsLabelUsed'
	| 'SPBenefitTokenCountsLabelTotal';

export const spBenefitTokenCountsLocs: LocDefs<SPBenefitTokenCountsLocs> = {
	SPBenefitTokenCountsLabelAvailable: {
		defaultValue: 'Available Individual Tokens',
		description: 'Label for displaying the count of available tokens',
		displayPath: 'Catalogs|Benefits|Tokens|AvailableTokens',
		displayType: 'Label',
		feature: HubFeature.Benefit,
		legacyName: 'Benefit/Catalogs.BenefitTokens.FieldLabel.AvailableTokens',
		portal: 'SP' as LocPortal,
	},
	SPBenefitTokenCountsLabelInvalid: {
		defaultValue: 'Invalid Individual Tokens',
		description: 'Label for displaying the count of invalid tokens',
		displayPath: 'Catalogs|Benefits|Tokens|InvalidTokens',
		displayType: 'Label',
		feature: HubFeature.Benefit,
		legacyName: 'Benefit/Catalogs.BenefitTokens.FieldLabel.InvalidTokens',
		portal: 'SP' as LocPortal,
	},
	SPBenefitTokenCountsLabelExpired: {
		defaultValue: 'Expired Individual Tokens',
		description: 'Label for displaying the count of expired tokens',
		displayPath: 'Catalogs|Benefits|Tokens|ExpiredTokens',
		displayType: 'Label',
		feature: HubFeature.Benefit,
		legacyName: 'Benefit/Catalogs.BenefitTokens.FieldLabel.ExpiredTokens',
		portal: 'SP' as LocPortal,
	},
	SPBenefitTokenCountsLabelUsed: {
		defaultValue: 'Individual Tokens Used',
		description: 'Label for displaying the count of used tokens',
		displayPath: 'Catalogs|Benefits|Tokens|UsedTokens',
		displayType: 'Label',
		feature: HubFeature.Benefit,
		legacyName: 'Benefit/Catalogs.BenefitTokens.FieldLabel.UsedTokens',
		portal: 'SP' as LocPortal,
	},
	SPBenefitTokenCountsLabelTotal: {
		defaultValue: 'Total Individual Tokens',
		description: 'Label for displaying the total count of tokens',
		displayPath: 'Catalogs|Benefits|Tokens|TotalTokens',
		displayType: 'Label',
		feature: HubFeature.Benefit,
		legacyName: 'Benefit/Catalogs.BenefitTokens.FieldLabel.TotalTokens',
		portal: 'SP' as LocPortal,
	},
};

export const LOC_KEYS = MapLocKeys<SPBenefitTokenCountsLocs>(spBenefitTokenCountsLocs);
export type SpBenefitTokenCountsLocKeys = LocMap<SPBenefitTokenCountsLocs>;
